<template>
  <li>
    <base-card-vue>
      <header>
        <h3>{{ title }}</h3>
        <base-button-vue mode="flat" @click="deleteMe">Delete</base-button-vue>
      </header>
      <p>{{ description }}</p>
      <nav>
        <a :href="link">{{ link }}</a>
      </nav>
    </base-card-vue>
  </li>
</template>

<script>
export default {
  inject: ['deleteResource'],
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: false },
    link: { type: String, required: false },
  },
  data() {
    return {};
  },
  methods: {
    deleteMe() {
      this.deleteResource(this.id);
    },
  },
};
</script>

<style scoped>
li {
  margin: auto;
  max-width: 40rem;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

h3 {
  font-size: 1.25rem;
  margin: 0.5rem 0;
}

p {
  margin: 0.5rem 0;
}

a {
  text-decoration: none;
  color: #ce5c00;
}

a:hover,
a:active {
  color: #c89300;
}
</style>
